import catalogue from './catalogue'

export default {
    name: 'Nouveautes',
    data() { return { opened: false, readIds: [], catalogue } },
    computed: {
        actorId() {
            const auth = this.$store.getters.authInfo || {}
            const actor = auth.user || auth
            return actor.id == null ? '' : String(actor.id)
        },
        storageKey() { return 'clinicaa:nouveautes:v1:' + catalogue.interface + ':' + this.actorId },
        entries() { return this.catalogue.entries },
        unreadCount() { return this.actorId ? this.entries.filter(entry => this.readIds.indexOf(entry.id) < 0).length : 0 },
        buttonLabel() { return 'Notifications — ' + catalogue.label + (this.unreadCount ? ' : ' + this.unreadCount + ' non lues' : '') }
    },
    watch: {
        storageKey: { immediate: true, handler() { this.opened = false; this.loadRead() } }
    },
    mounted() { window.addEventListener('storage', this.onStorage) },
    beforeDestroy() { window.removeEventListener('storage', this.onStorage) },
    methods: {
        toggle() { this.opened = !this.opened },
        close() {
            this.opened = false
            this.$nextTick(() => this.$refs.trigger.focus())
        },
        loadRead() {
            this.readIds = []
            if (!this.actorId) return
            try {
                const value = JSON.parse(window.localStorage.getItem(this.storageKey) || '[]')
                if (Array.isArray(value)) this.readIds = value.filter(id => typeof id === 'string')
            } catch (_) { /* Storage can be disabled without blocking the feature. */ }
        },
        markRead() {
            if (!this.actorId) return
            this.readIds = this.entries.map(entry => entry.id)
            try { window.localStorage.setItem(this.storageKey, JSON.stringify(this.readIds)) } catch (_) { /* Memory-only fallback. */ }
            this.$nextTick(() => { if (this.$refs.close) this.$refs.close.focus() })
        },
        markEntryRead(id) {
            if (!this.actorId || this.readIds.indexOf(id) >= 0) return
            this.readIds = this.readIds.concat([id])
            try { window.localStorage.setItem(this.storageKey, JSON.stringify(this.readIds)) } catch (_) { /* Memory-only fallback. */ }
        },
        onStorage(event) { if (event.key === this.storageKey || event.key === null) this.loadRead() },
        displayDate(date) { return date.split('-').reverse().join('/') }
    }
}
